<gp-dropdown-select [(ngModel)]="selectedPayType"
                    id="selectPayType"
                    [customPlaceholderGenerator]="customPlaceholderGenerator"
                    (ngModelChange)="selectPayType($event)"
                    [forceDisplayValue]="forceDisplayValue"
                    class="context-select"
                    ngDefaultControl>
  <ng-container *ngFor="let payTypeGroup of payTypesMap | keyvalue : keepOrder">
    <gp-dropdown-option *ngFor="let payType of payTypeGroup.value; let i = index"
                        [ngValue]="payType"
                        [class.context-select-group]="i === 0"
                        [class.active]="payType === selectedPayType">
      {{displayPayTypeText(payType) | translate}}
    </gp-dropdown-option>
  </ng-container>
</gp-dropdown-select>
